// The Team's global pages, in one row (COHERE2 P1-16). Each was reachable only
// from the reviewer's queue or from a sentence inside another tab, so the team
// home linked to none of them. One name per page: the link text is the page's
// own title. Rendered under the Customers title and, on a phone, in the
// account menu (the top bar collapses everything else behind that button).

import { Link } from 'react-router-dom';
import { firmWords } from '../firm/strings/firm';

export const TEAM_LINKS: { to: string; label: string }[] = [
  { to: '/', label: 'Customers' },
  { to: '/legislation', label: 'Changes in the law' },
  { to: '/admin/source-health', label: 'Source health' },
  { to: '/admin/research', label: 'Research publishing' },
  { to: '/admin/users', label: 'Everyone with access' },
  { to: '/admin/firm-referrals', label: firmWords.requestsTitle },
  { to: '/admin/activation', label: 'Activation' },
  { to: '/admin/part-requests', label: 'Part requests' },
  { to: '/admin/source-requests', label: 'Source problems' },
  { to: '/portfolios', label: 'Portfolios' },
];

// `hideCurrent` drops the link to the page the row sits on when that page's own
// title is shown beside it (UXWALK P2-10: "Customers" as the title AND the
// first link).
export function TeamLinks({
  className = '',
  current,
  hideCurrent = false,
}: {
  className?: string;
  current?: string;
  hideCurrent?: boolean;
}) {
  return (
    <nav className={`cx-team-links ${className}`.trim()} aria-label="Team pages">
      {TEAM_LINKS.filter((l) => !(hideCurrent && l.to === current)).map((l) => (
        <Link key={l.to} to={l.to} aria-current={l.to === current ? 'page' : undefined}>
          {l.label}
        </Link>
      ))}
    </nav>
  );
}
